module.exports = __webpack_public_path__ + "img/product_express_error.73fbb76.png";